require('./ledgers.scss');
const controller = require('./ledgersCtrl').default;
const template = require('./ledgers.html');

const deps = [
  require('angular-ui-router'),
  require('data/collection/ledgerCategory').name,
  require('data/collection/ledgerCategoryOrder').name,
  require('data/collection/ledger').name,
  require('data/collection/addon').name,
  require('ui/bk/angularMaterial').name,
  require('ui/bk/ledgerList').name,
  require('ui/bk/addonList').name,
  require('ui/bk/editLedger').name,
  require('ui/bk/editAddon').name,
  require('ui/bk/editLedgerNew').name,
];

module.exports = angular.module('bench.ui.ledgers', deps).component('blLedgers', {
  bindings: {
    ledgerCollectionId: '<',
    selectedTab: '<',
  },
  template,
  controller,
  controllerAs: 'vm',
});
